<div *ngIf="!loading" class="container-fluid marginLeft4rem">
    <div *ngIf="enableAlarmDetail" class="row volver" (click)="goBackAlarmTable()"> 
        <app-svg class="icon-arrow-left pointer margen" name="arrow-left"></app-svg>
        <div class="margen styleGoOnBack pointer"> {{'ALARM.BACK_TO' | translate}}</div>
    </div>
    <div *ngIf="!enableAlarmDetail && !enableAlarmForm" class="row">
        <div class="col-6 budgetStyle">
            <app-alarm-budget (budgetCollectionEmitter)="filterByState($event)" [budgetCollection]="budgetCollection">
            </app-alarm-budget>
        </div>

        <div class="col-6 buttonPosition">
            <button mat-mini-fab matTooltip="{{'ALARM.ADD_ALARM' | translate}}" matTooltipPosition='above'
                matTooltipClass='addAlarm' class="float-right addAlarm1 margin" (click)="showAlarmForm()">
                <mat-icon>add</mat-icon>
            </button>
        </div>

    </div>
    <div class="row">
        <div class="container-fluid tableStyle">
            <app-alarm-table *ngIf="!enableAlarmForm && !enableAlarmDetail"
            [elementData]="elementData"
            [activatedStyle]="activatedStyle"
            (selectionStateEmitter)="controlStateButtonStyle($event)" 
            (selectionRowEmitter)="showAlarmDetail($event)"
            (deleteAlarmEmitter)="showModalForDeleteAlarm($event)"
            (editAlarmEmitter)="showFormForEditAlarm($event)"
            (changeAlarmStateEmitter)="showModalForChangeAlarmState($event)">
            </app-alarm-table>
            <div class="alarmForm">
                <app-alarm-form *ngIf="enableAlarmForm" [formMode]="formMode" (cancelEmitter)="cancelForm()"
                [alarmToEdit]="alarmToEdit" (submitEmitter)="submitForm($event)"></app-alarm-form>
            </div>
            <app-alarm-detail *ngIf="enableAlarmDetail" [detailedAlarm]="detailedAlarm"></app-alarm-detail>
        </div>
    </div>      
</div>

<app-loading *ngIf="loading" [loadingText]="'Cargando alarmas...'" ></app-loading>